//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './PatientListConfigurationClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type GetPatientListConfigurationPatientListConfigurationQueryParameters = {
  id: number ;
}

export type EditPatientListConfigurationPatientListConfigurationQueryParameters = {
  id: number ;
}

export type RemovePatientListConfigurationPatientListConfigurationQueryParameters = {
  id: number ;
}

export type PinPatientListConfigurationPatientListConfigurationQueryParameters = {
  id: number ;
}

export function getPatientListConfigurationUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/patient-list-configuration/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getPatientListConfigurationDefaultOptions: Omit<UseQueryOptions<Types.PatientListConfigurationDto, unknown, Types.PatientListConfigurationDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.PatientListConfigurationDto, unknown, Types.PatientListConfigurationDto>, 'queryFn'>> = {
};
export function getGetPatientListConfigurationDefaultOptions() {
  return getPatientListConfigurationDefaultOptions;
};
export function setGetPatientListConfigurationDefaultOptions(options: typeof getPatientListConfigurationDefaultOptions) {
  getPatientListConfigurationDefaultOptions = options;
}

export function getPatientListConfigurationQueryKey(id: number): QueryKey;
export function getPatientListConfigurationQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { id,  } = params[0] as GetPatientListConfigurationPatientListConfigurationQueryParameters;

    return trimArrayEnd([
        'PatientListConfigurationClient',
        'getPatientListConfiguration',
        id as any,
      ]);
  } else {
    return trimArrayEnd([
        'PatientListConfigurationClient',
        'getPatientListConfiguration',
        ...params
      ]);
  }
}
export function __getPatientListConfiguration(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getPatientListConfiguration(
      context.queryKey[2] as number,axiosConfig    );
}

export function useGetPatientListConfigurationQuery<TSelectData = Types.PatientListConfigurationDto, TError = unknown>(dto: GetPatientListConfigurationPatientListConfigurationQueryParameters, options?: Omit<UseQueryOptions<Types.PatientListConfigurationDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Gets a PatientList configuration by id.
 * @param id Id of PatientList configuration.
 */
export function useGetPatientListConfigurationQuery<TSelectData = Types.PatientListConfigurationDto, TError = unknown>(id: number, options?: Omit<UseQueryOptions<Types.PatientListConfigurationDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetPatientListConfigurationQuery<TSelectData = Types.PatientListConfigurationDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.PatientListConfigurationDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let id: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ id,  } = params[0] as GetPatientListConfigurationPatientListConfigurationQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [id, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.PatientListConfigurationDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getPatientListConfiguration(context, axiosConfig) : __getPatientListConfiguration,
    queryKey: getPatientListConfigurationQueryKey(id),
    ...getPatientListConfigurationDefaultOptions as unknown as Omit<UseQueryOptions<Types.PatientListConfigurationDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Gets a PatientList configuration by id.
 * @param id Id of PatientList configuration.
 */
export function setGetPatientListConfigurationData(queryClient: QueryClient, updater: (data: Types.PatientListConfigurationDto | undefined) => Types.PatientListConfigurationDto, id: number) {
  queryClient.setQueryData(getPatientListConfigurationQueryKey(id),
    updater
  );
}

/**
 * Gets a PatientList configuration by id.
 * @param id Id of PatientList configuration.
 */
export function setGetPatientListConfigurationDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.PatientListConfigurationDto | undefined) => Types.PatientListConfigurationDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function editPatientListConfigurationUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/patient-list-configuration/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function editPatientListConfigurationMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'PatientListConfigurationClient',
      'editPatientListConfiguration',
      id as any,
    ]);
}

export function useEditPatientListConfigurationMutation<TContext>(id: number, options?: Omit<UseMutationOptions<Types.PatientListConfigurationDto, unknown, Types.UpdatePatientListConfigurationDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.PatientListConfigurationDto, unknown, Types.UpdatePatientListConfigurationDto, TContext> {
  const key = editPatientListConfigurationMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (updateDto: Types.UpdatePatientListConfigurationDto) => Client.editPatientListConfiguration(id, updateDto),
    mutationKey: key,
  });
}
  
type EditPatientListConfiguration__MutationParameters = EditPatientListConfigurationPatientListConfigurationQueryParameters & {
  updateDto: Types.UpdatePatientListConfigurationDto;
}

export function useEditPatientListConfigurationMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.PatientListConfigurationDto, unknown, EditPatientListConfiguration__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: EditPatientListConfigurationPatientListConfigurationQueryParameters}): UseMutationResult<Types.PatientListConfigurationDto, unknown, EditPatientListConfiguration__MutationParameters, TContext> {
  const key = editPatientListConfigurationMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: EditPatientListConfiguration__MutationParameters) => Client.editPatientListConfiguration(data.id ?? options?.parameters?.id!, data.updateDto),
  mutationKey: key,
});
}
  
export function removePatientListConfigurationUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/patient-list-configuration/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function removePatientListConfigurationMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'PatientListConfigurationClient',
      'removePatientListConfiguration',
      id as any,
    ]);
}

export function useRemovePatientListConfigurationMutation<TContext>(id: number, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = removePatientListConfigurationMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.removePatientListConfiguration(id),
    mutationKey: key,
  });
}
  
type RemovePatientListConfiguration__MutationParameters = RemovePatientListConfigurationPatientListConfigurationQueryParameters

export function useRemovePatientListConfigurationMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, RemovePatientListConfiguration__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: RemovePatientListConfigurationPatientListConfigurationQueryParameters}): UseMutationResult<void, unknown, RemovePatientListConfiguration__MutationParameters, TContext> {
  const key = removePatientListConfigurationMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: RemovePatientListConfiguration__MutationParameters) => Client.removePatientListConfiguration(data.id ?? options?.parameters?.id!),
  mutationKey: key,
});
}
  
export function getPatientListConfigurationsUrl(): string {
  let url_ = getBaseUrl() + "/api/patient-list-configuration";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getPatientListConfigurationsDefaultOptions: Omit<UseQueryOptions<Types.PatientListConfigurationListDto[], unknown, Types.PatientListConfigurationListDto[]>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.PatientListConfigurationListDto[], unknown, Types.PatientListConfigurationListDto[]>, 'queryFn'>> = {
};
export function getGetPatientListConfigurationsDefaultOptions() {
  return getPatientListConfigurationsDefaultOptions;
};
export function setGetPatientListConfigurationsDefaultOptions(options: typeof getPatientListConfigurationsDefaultOptions) {
  getPatientListConfigurationsDefaultOptions = options;
}

export function getPatientListConfigurationsQueryKey(): QueryKey;
export function getPatientListConfigurationsQueryKey(...params: any[]): QueryKey {
  return trimArrayEnd([
      'PatientListConfigurationClient',
      'getPatientListConfigurations',
    ]);
}
export function __getPatientListConfigurations(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getPatientListConfigurations(
axiosConfig    );
}

/**
 * Get all available configurations for user (created by user or shared between all users)
 */
export function useGetPatientListConfigurationsQuery<TSelectData = Types.PatientListConfigurationListDto[], TError = unknown>(options?: Omit<UseQueryOptions<Types.PatientListConfigurationListDto[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetPatientListConfigurationsQuery<TSelectData = Types.PatientListConfigurationListDto[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.PatientListConfigurationListDto[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  

  options = params[0] as any;
  axiosConfig = params[1] as any;

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.PatientListConfigurationListDto[], TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getPatientListConfigurations(context, axiosConfig) : __getPatientListConfigurations,
    queryKey: getPatientListConfigurationsQueryKey(),
    ...getPatientListConfigurationsDefaultOptions as unknown as Omit<UseQueryOptions<Types.PatientListConfigurationListDto[], TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Get all available configurations for user (created by user or shared between all users)
 */
export function setGetPatientListConfigurationsData(queryClient: QueryClient, updater: (data: Types.PatientListConfigurationListDto[] | undefined) => Types.PatientListConfigurationListDto[], ) {
  queryClient.setQueryData(getPatientListConfigurationsQueryKey(),
    updater
  );
}

/**
 * Get all available configurations for user (created by user or shared between all users)
 */
export function setGetPatientListConfigurationsDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.PatientListConfigurationListDto[] | undefined) => Types.PatientListConfigurationListDto[]) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function createPatientListConfigurationUrl(): string {
  let url_ = getBaseUrl() + "/api/patient-list-configuration";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function createPatientListConfigurationMutationKey(): MutationKey {
  return trimArrayEnd([
      'PatientListConfigurationClient',
      'createPatientListConfiguration',
    ]);
}

export function useCreatePatientListConfigurationMutation<TContext>(options?: Omit<UseMutationOptions<Types.PatientListConfigurationDto, unknown, Types.CreatePatientListConfigurationDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.PatientListConfigurationDto, unknown, Types.CreatePatientListConfigurationDto, TContext> {
  const key = createPatientListConfigurationMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (createDto: Types.CreatePatientListConfigurationDto) => Client.createPatientListConfiguration(createDto),
    mutationKey: key,
  });
}
  
export function pinPatientListConfigurationUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/patient-list-configuration/pin/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function pinPatientListConfigurationMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'PatientListConfigurationClient',
      'pinPatientListConfiguration',
      id as any,
    ]);
}

export function usePinPatientListConfigurationMutation<TContext>(id: number, options?: Omit<UseMutationOptions<void, unknown, Types.PinPatientListConfigurationDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.PinPatientListConfigurationDto, TContext> {
  const key = pinPatientListConfigurationMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.PinPatientListConfigurationDto) => Client.pinPatientListConfiguration(id, dto),
    mutationKey: key,
  });
}
  
type PinPatientListConfiguration__MutationParameters = PinPatientListConfigurationPatientListConfigurationQueryParameters & {
  dto: Types.PinPatientListConfigurationDto;
}

export function usePinPatientListConfigurationMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, PinPatientListConfiguration__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: PinPatientListConfigurationPatientListConfigurationQueryParameters}): UseMutationResult<void, unknown, PinPatientListConfiguration__MutationParameters, TContext> {
  const key = pinPatientListConfigurationMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: PinPatientListConfiguration__MutationParameters) => Client.pinPatientListConfiguration(data.id ?? options?.parameters?.id!, data.dto),
  mutationKey: key,
});
}